var _excluded = ["hidden", "count", "page", "onChangePage", "rowsPerPage", "onChangeRowsPerPage"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { styled } from '@mui/material/styles';
import TablePagination from '@mui/material/TablePagination';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { TablePaginationStyles } from "../../common";
var PREFIX = 'BrandTablePagination';
var classes = {
  tablePagination: "".concat(PREFIX, "-tablePagination")
};
var StyledTablePagination = styled(TablePagination)(function (_ref) {
  var theme = _ref.theme;
  return _objectSpread(_objectSpread({}, TablePaginationStyles(theme)), {}, _defineProperty({
    overflow: 'hidden',
    '& p': {
      margin: 0
    },
    '& .MuiToolbar-root': {
      flexWrap: 'wrap',
      justifyContent: 'center',
      '& .MuiTablePagination-spacer': {
        display: 'none'
      }
    }
  }, "& .".concat(classes.tablePagination), {
    display: 'flex',
    justifyContent: 'center'
  }));
});
var BrandTablePagination = function BrandTablePagination(_ref2) {
  var hidden = _ref2.hidden,
    count = _ref2.count,
    page = _ref2.page,
    onChangePage = _ref2.onChangePage,
    rowsPerPage = _ref2.rowsPerPage,
    onChangeRowsPerPage = _ref2.onChangeRowsPerPage,
    others = _objectWithoutProperties(_ref2, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(StyledTablePagination, _extends({
    labelRowsPerPage: t('rows_per_page'),
    className: clsx(classes.tablePagination, _defineProperty({}, classes.hidden, hidden)),
    component: "div",
    count: count || 0,
    page: count ? page : 0,
    SelectProps: {
      MenuProps: {
        disablePortal: true
      }
    },
    onPageChange: onChangePage,
    rowsPerPage: rowsPerPage,
    onRowsPerPageChange: onChangeRowsPerPage
  }, others));
};
export default BrandTablePagination;